(function () {
  var HOVER_DELAY = 120;

  function initHoverMenus() {
    var headerMenus = document.querySelectorAll(
      '.header__inline-menu header-menu'
    );

    headerMenus.forEach(function (headerMenu) {
      var details = headerMenu.querySelector('details');
      if (!details) return;

      var closeTimer = null;

      function openMenu() {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
          var summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }
      }

      function closeMenu() {
        closeTimer = setTimeout(function () {
          if (details.hasAttribute('open')) {
            details.removeAttribute('open');
            var summary = details.querySelector('summary');
            if (summary) summary.setAttribute('aria-expanded', 'false');
          }
          closeTimer = null;
        }, HOVER_DELAY);
      }

      headerMenu.addEventListener('mouseenter', openMenu);
      headerMenu.addEventListener('mouseleave', closeMenu);

      var summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (event) {
          if (window.matchMedia('(min-width: 990px)').matches) {
            event.preventDefault();
            if (!details.hasAttribute('open')) {
              openMenu();
            }
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMenus);
  } else {
    initHoverMenus();
  }
})();